import * as React from "react";
const SvgStopIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 5, y: 5, width: 10, height: 10, rx: 2, fill: "currentColor" }));
export default SvgStopIcon;
